import React from 'react'
import {connect} from 'react-redux'
import {withSiteData} from 'react-static'
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';

import {updateProduct} from '../actions/products'
import ProductForm from '../components/ProductForm'

class NewProductModal extends React.Component {
  constructor(props){
    super(props)
    this.state = {show: true}
  }

  close = () => this.setState({show: false})

  restoreUrl = () => {
    this.props.history.replace(this.props.backPath || '/products')
  }

  handleSubmit = (values) => this.props.submit(values).then(this.close)

  render() {
    return(
      <Modal
        size='lg'
        isOpen={this.state.show}
        toggle={this.close}
        onClosed={this.restoreUrl}>
        <ModalHeader toggle={this.props.close}>Neues Produkt</ModalHeader>

        <ProductForm
          product={this.props.product}
          submit={this.handleSubmit}
          bodyComponent={ModalBody}
          buttonsComponent={({children}) =>
            <ModalFooter>
              {children}
              <Button color="secondary" onClick={this.close}>Abbrechen</Button>
            </ModalFooter>
          }/>
      </Modal>
    )
  }
}
export default connect(
  (state,ownProps) => {
    const product = state.products.items.find(c => c.id===ownProps.match.params.id)
    return {
      product,
      isFetching: !product
    }
  },
  dispatch => ({
    submit: (payload) => dispatch(updateProduct(payload))
  })
)(withSiteData(NewProductModal))



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/containers/ShowProduct.js